
import { defineComponent, PropType } from 'vue';
import ConhecimentoTransporteDocumentos from './ConhecimentoTransporteDocumentos.vue';
import ConhecimentoTransporteImpostos from './ConhecimentoTransporteImpostos.vue';
import ConhecimentoTransporteFinanceiro from './ConhecimentoTransporteFinanceiro.vue';
import { ICteDocumentoReferenciado } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteDocumentoReferenciado';
import { ICteImposto } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteImposto';

export default defineComponent({
  name: 'ConhecimentoTransporteAbas',
  components: {
    ConhecimentoTransporteDocumentos,
    ConhecimentoTransporteImpostos,
    ConhecimentoTransporteFinanceiro,
  },
  props: {
    documentos: {
      type: Array as PropType<ICteDocumentoReferenciado[]>,
    },
    impostos: {
      type: Array as PropType<ICteImposto[]>,
    },
  },
  emits: ['update:documentos', 'update:impostos'],
});
